var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "41px",
    viewBox: "0 0 45 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_generic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.473,0.727 C9.75,0.727 9.163,1.313 9.163,2.037 L9.163,2.037 L9.163,38.691 C9.163,39.414 9.75,40.001 10.473,40.001 L10.473,40.001 L34.037,40.001 C34.759,40.001 35.346,39.414 35.346,38.691 L35.346,38.691 L35.346,10.608 C35.346,10.273 35.217,9.949 34.985,9.706 L34.985,9.706 L26.818,1.133 C26.571,0.874 26.229,0.727 25.871,0.727 L25.871,0.727 L10.473,0.727 Z M11.781,3.345 L23.563,3.345 L23.564,13.818 L32.727,13.817 L32.728,37.382 L11.781,37.382 L11.781,3.345 Z M26.181,4.261 L32.728,11.132 L32.727,11.2 L26.182,11.2 L26.181,4.261 Z M5.96,6.102 L0.724,8.72 C0.141,9.012 -0.138,9.687 0.068,10.305 L0.068,10.305 L5.304,26.014 C5.533,26.7 6.273,27.07 6.959,26.842 L6.959,26.842 C7.646,26.614 8.016,25.871 7.787,25.186 L7.787,25.186 L2.911,10.554 L7.131,8.444 C7.777,8.121 8.039,7.334 7.716,6.687 L7.716,6.687 C7.487,6.229 7.025,5.964 6.544,5.964 L6.544,5.964 C6.348,5.964 6.148,6.008 5.96,6.102 L5.96,6.102 Z M36.738,15.322 C36.484,15.999 36.827,16.753 37.504,17.007 L37.504,17.007 L41.587,18.538 L36.712,34.378 C36.501,35.069 36.888,35.802 37.578,36.014 L37.578,36.014 C38.27,36.227 39.003,35.84 39.215,35.149 L39.215,35.149 L44.451,18.13 C44.655,17.468 44.308,16.762 43.659,16.52 L43.659,16.52 L38.423,14.556 C38.272,14.499 38.117,14.472 37.964,14.472 L37.964,14.472 C37.434,14.472 36.935,14.796 36.738,15.322 L36.738,15.322 Z M15.709,19.055 C14.986,19.055 14.4,19.641 14.4,20.363 L14.4,20.363 C14.4,21.087 14.986,21.673 15.709,21.673 L15.709,21.673 L28.8,21.673 C29.523,21.673 30.109,21.087 30.109,20.363 L30.109,20.363 C30.109,19.641 29.523,19.055 28.8,19.055 L28.8,19.055 L15.709,19.055 Z M15.709,24.291 C14.986,24.291 14.4,24.877 14.4,25.6 L14.4,25.6 C14.4,26.323 14.986,26.909 15.709,26.909 L15.709,26.909 L24.873,26.909 C25.596,26.909 26.182,26.323 26.182,25.6 L26.182,25.6 C26.182,24.877 25.596,24.291 24.873,24.291 L24.873,24.291 L15.709,24.291 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyphs/Policies/Generic",
    transform: "translate(-3.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_generic",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#C1C9EA",
    points: "27.1811 4.5332 27.1821 11.4722 33.7271 11.4722 33.7281 11.4052"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 0.272700)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#003DA5",
    mask: "url(#mask-2)",
    points: "-5 45 49.509 45 49.509 -4.273 -5 -4.273"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeneric);
export default __webpack_public_path__ + "static/media/Icon-generic.96249affc36654be9166efae94f6b5f3.svg";
export { ForwardRef as ReactComponent };